import styles from "@/styles/productReviews/index.module.scss";
import GoodsComponentWithDiscountNew from "@/components/GoodsComponentWithDiscountNew";

interface ProductItem {
  productID: number;
  name: string;
  url: string;
  imgUrl?: string;

  thumbnail?: string;
  smallThumbnail?: string;
  newThumbnail?: string;
  filename?: string;

  price: number;
  normalPrice: number;

  isGroup: number;
  inStock: number;
  preSales: number;

  freeShipping: number;
  onSale: number;
  reduced: number;
  isNew: number;
  isEmailOnly: any,
  promotionTypeID: number;

  promotion: {
    productID: number;
    promotionType: number;
    promotionPrice: number;
    normalPrice: number;
    endDate: string;
    pointRate: string;
    promotionRate: number;
  };
  review: {
    avgRank: number;
    total: number;
  };

  [key: string]: any;
}

interface Props {
  productList: ProductItem[];
}
export default function SimilarProducts({ productList }: Props) {
  if (!productList?.length) return null;

  return (
    <div className={styles["similar-products"]}>
      {productList.map((item: any) => (
        <GoodsComponentWithDiscountNew
          key={item.productID}
          {...item}
        />
      ))}
    </div>
  );
}